import { Component, computed, OnDestroy, OnInit } from '@angular/core';
import { RatecapItems, requestforEmulationPayload } from '../../../../shared/models/model';
import { WidgetsService } from '../../../../shared/services/widgets.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { EmulationService } from '../../../../shared/services/emulation.service';
import { SkeletonLineComponent } from '../../../../pages/skeleton-line/skeleton-line.component';

@Component({
  selector: 'app-ratecap',
  standalone: true,
  imports: [CommonModule, RouterModule, SkeletonLineComponent],
  templateUrl: './ratecap.component.html',
  styleUrl: './ratecap.component.scss',
})
export class RatecapComponent implements OnInit, OnDestroy {
  ratecapInfos: RatecapItems[] = [];
  errorMessage: string = '';
  rateCapsSubscription: Subscription = new Subscription();
  emulatedUser = computed(() => this._emulationService.emulatedUser());
  isLoading: boolean = false;

  constructor(
    private _widgetService: WidgetsService,
    private _emulationService: EmulationService,
  ) {}

  ngOnInit(): void {
    this.getRatecapInfo();
  }

  getRatecapInfo(): void {
    this.isLoading = true;
    // payload for fetching promos
    const payLoad: requestforEmulationPayload = {
      requestingSystem: 'FinPro',
      isEmulating: this.emulatedUser() ? true : false,
      emulatingUserId: this.emulatedUser()?.userId || '',
    };
    setTimeout(() => {
      this.rateCapsSubscription = this._widgetService.fetchRateCaps(payLoad).subscribe({
        next: (data: any) => {
          this.ratecapInfos =
            data && data.rateCapList ? data.rateCapList.filter((value: any, idx: number) => idx < 3) : [];
          this.isLoading = false;
        },
        error: (error: string) => {
          this.errorMessage = error;
          this.isLoading = false;
        },
      });
    }, 2000);
  }
  ngOnDestroy(): void {
    this.rateCapsSubscription.unsubscribe();
  }
}
